<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Tags from '@/components/android/Tags.vue';

const store = useStore();
const info = computed(() => store.state.appInfo);
</script>

<template>
  <div class="footer flex justify-between">
    <ul>
      <li>{{ info.language_list.footer.google_play }}</li>
      <li>{{ info.language_list.footer.play_pass }}</li>
      <li>{{ info.language_list.footer.play_points }}</li>
      <li>{{ info.language_list.footer.gift_cards }}</li>
      <li>{{ info.language_list.footer.redeem }}</li>
      <li>{{ info.language_list.footer.refund_policy }}</li>
    </ul>
    <ul>
      <li>{{ info.language_list.footer.kids_family }}</li>
      <li>{{ info.language_list.footer.parent_guide }}</li>
      <li>{{ info.language_list.footer.family_sharing }}</li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.footer {
  padding: 16px 24px 100px 16px;
  font-size: 14px;
  color: #666;
  border-top: 1px solid #ddd;
  ul {
    flex: 1;
    margin-right: 10px;
  }
  ul > li {
    line-height: 35px;
  }
}
</style>
